export default class ReadMore {
  constructor() {
    this.getDomElements()

    if (!this.dom.readMore.length) return

    this.init()
  }


  init() {
    this.maxHeight = '75'
    this.elements = []

    this.setup()

    this.handleClick()
    this.handleResize()
  }

  setup() {
    this.dom.readMore.forEach(element => {
      // Create HTML
      let trigger = document.createElement('div')
      trigger.innerHTML = 'Read more <ion-icon class="u-icon u-icon--small u-ml-quarter u-font-bold" name="chevron-down"></ion-icon>'
      trigger.classList.add('e-read-more__trigger', 'u-mt', 'u-flex', 'u-v-center')
      trigger.style.display = 'none'
      element.after(trigger)

      const elementHeight  = element.scrollHeight

      this.elements.push({
        'element' : element,
        'trigger' : trigger,
        'height' : elementHeight,
        'active' : elementHeight > this.maxHeight ? true : false,
        'open' : false,
      })
    })

    this.setActive()
  }

  refresh() {
    this.elements.forEach(element => {
      const elementHeight  = element.element.scrollHeight
      element.height = elementHeight
      element.active = elementHeight > this.maxHeight ? true : false,
      element.trigger.style.display = 'none'
    })
    this.setActive()
  }

  setActive() {
    this.elements.forEach(element => {
      if (element.active) {
        element.trigger.style.display = 'flex'
        element.element.style.maxHeight = `${this.maxHeight}px`
      }
    })
  }

  handleClick() {
    this.elements.forEach(element => {
      element.trigger.addEventListener('click', () => {
        element.trigger.classList.toggle('is-active')
        element.element.style.maxHeight = element.open ? `${this.maxHeight}px` : `${element.height}px`
        element.trigger.innerHTML =  element.open ? 'Read more <ion-icon class="u-icon u-icon--small u-ml-quarter u-font-bold" name="chevron-down"></ion-icon>' : 'Read less <ion-icon class="u-icon u-icon--small u-ml-quarter u-font-bold" name="chevron-up"></ion-icon>'
        element.open = !element.open
      })
    })
  }


  handleResize() {
    window.addEventListener('resize', () => {
      this.refresh()
    })
  }


  getDomElements() {
    this.dom = {
      'readMore' : document.querySelectorAll('[data-read-more]') 
    }
  }
}